import OneSignal from 'react-onesignal';
import { WithTimeout } from './AsyncHelpers';

const ONE_SIGNAL_STEP_TIMEOUT_MS = 10000

// 'unknown' covers everything the user cannot act on: a failed setup, an unsupported
// browser, or a prompt they have not answered yet. Only 'blocked' is worth showing.
export type PushNotificationStatus = 'unknown' | 'enabled' | 'blocked'

// Read from the browser rather than the OneSignal SDK, since this is about whether the
// user will get notified at all, and a setup that failed halfway still has a real answer.
function ReadPushNotificationStatus(): PushNotificationStatus {
	if (typeof Notification === 'undefined') {
		return 'unknown'
	}
	if (Notification.permission === 'granted') {
		return 'enabled'
	}
	if (Notification.permission === 'denied') {
		return 'blocked'
	}
	return 'unknown'
}

// Must never throw: push notification setup cannot be allowed to break login.
export async function OneSignalInit(userSK: string): Promise<PushNotificationStatus> {
	const appId = process.env.REACT_APP_ONE_SIGNAL_APP_ID || ''
	const isLocal = process.env.REACT_APP_ENVIRONMENT === "Local"
	if (isLocal || !appId) {
		return 'unknown'
	}
	try {
		await WithTimeout(OneSignal.init({
			appId: appId,
			allowLocalhostAsSecureOrigin: true,
		}), ONE_SIGNAL_STEP_TIMEOUT_MS, 'OneSignal.init')
		await WithTimeout(OneSignal.login(userSK), ONE_SIGNAL_STEP_TIMEOUT_MS, 'OneSignal.login')
		await WithTimeout(OneSignal.User.PushSubscription.optIn(), ONE_SIGNAL_STEP_TIMEOUT_MS, 'OneSignal.optIn')
	} catch (error) {
		console.error("OneSignal setup skipped:", error)
	}
	return ReadPushNotificationStatus()
}

export async function OneSignalLogOut() {
	const isLocal = process.env.REACT_APP_ENVIRONMENT === 'Local'
	if (isLocal) {
		return
	}
	try {
		if (!OneSignal.Session) {
			return
		}
		await OneSignal.User.PushSubscription.optOut()
		await OneSignal.logout()
	} catch (error) {
		console.error("Error loginOut OneSignal:", error)
	}
}
